import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
{
    id: "po-06-h1v5-01",
    name: "PO 01 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 69, y: 139, width: 472, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 476, width: 152, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 476, width: 152, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 390, y: 476, width: 151, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 666, y: 250, width: 243, height: 351, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 250, width: 243, height: 351, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-02",
    name: "PO 02 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 126, y: 160, width: 358, height: 530, rotation: 0, imageRotation: 0 },
            { id: "2", x: 652, y: 160, width: 167, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 652, y: 430, width: 167, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 827, y: 430, width: 167, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1002, y: 430, width: 167, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 827, y: 160, width: 342, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "hs-06-h1v5-03",
    name: "HS 03 - H1V5",
    albumType: "HS",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 131, y: 166, width: 163, height: 264, rotation: 0, imageRotation: 0 },
        { id: "2", x: 302, y: 166, width: 162, height: 264, rotation: 0, imageRotation: 0 },
        { id: "3", x: 131, y: 438, width: 333, height: 247, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 166, width: 332, height: 519, rotation: 0, imageRotation: 0 },
        { id: "5", x: 997, y: 166, width: 164, height: 255, rotation: 0, imageRotation: 0 },
        { id: "6", x: 997, y: 430, width: 164, height: 255, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-04",
    name: "PO 04 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 73, y: 187, width: 463, height: 298, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 73, y: 493, width: 110, height: 171, rotation: 0, imageRotation: 0 },
        { id: "3", x: 191, y: 493, width: 110, height: 171, rotation: 0, imageRotation: 0 },
        { id: "4", x: 309, y: 493, width: 110, height: 171, rotation: 0, imageRotation: 0 },
        { id: "5", x: 427, y: 493, width: 109, height: 171, rotation: 0, imageRotation: 0 },
        { id: "6", x: 759, y: 187, width: 307, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-05",
    name: "PO 05 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 50, y: 220, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "2", x: 50, y: 429, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "3", x: 186, y: 220, width: 578, height: 410, rotation: 0, imageRotation: 0 },
        { id: "4", x: 772, y: 220, width: 257, height: 410, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1037, y: 220, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1037, y: 429, width: 128, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-06",
    name: "PO 06 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 45, y: 220, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "2", x: 45, y: 429, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "3", x: 181, y: 220, width: 578, height: 410, rotation: 0, imageRotation: 0 },
        { id: "4", x: 907, y: 220, width: 265, height: 410, rotation: 0, imageRotation: 0 },
        { id: "5", x: 767, y: 220, width: 132, height: 201, rotation: 0, imageRotation: 0 },
        { id: "6", x: 767, y: 429, width: 132, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-07",
    name: "PO 07 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 50, y: 220, width: 128, height: 202, rotation: 0, imageRotation: 0 },
        { id: "2", x: 186, y: 220, width: 128, height: 202, rotation: 0, imageRotation: 0 },
        { id: "3", x: 50, y: 430, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "4", x: 186, y: 430, width: 128, height: 201, rotation: 0, imageRotation: 0 },
        { id: "5", x: 322, y: 221, width: 577, height: 410, rotation: 0, imageRotation: 0 },
        { id: "6", x: 907, y: 221, width: 258, height: 410, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-08",
    name: "PO 08 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 246, width: 204, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 212, y: 246, width: 204, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 424, y: 246, width: 446, height: 337, rotation: 0, imageRotation: 0 },
        { id: "4", x: 878, y: 246, width: 212, height: 337, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1098, y: 246, width: 117, height: 165, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1098, y: 419, width: 117, height: 164, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-09",
    name: "PO 09 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 49, y: 144, width: 176, height: 278, rotation: 0, imageRotation: 0 },
        { id: "2", x: 49, y: 430, width: 176, height: 278, rotation: 0, imageRotation: 0 },
        { id: "3", x: 233, y: 144, width: 808, height: 564, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1049, y: 144, width: 119, height: 183, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1049, y: 335, width: 119, height: 183, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1049, y: 526, width: 119, height: 182, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h1v5-10",
    name: "PO 10 - H1V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 58, y: 169, width: 685, height: 513, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 169, width: 200, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 169, width: 199, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 751, y: 481, width: 131, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 481, width: 131, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1029, y: 481, width: 131, height: 201, rotation: 0, imageRotation: 0 }
    ],
}
];